import * as request from '../../request'
import * as serializers from './serializers'
// eslint-disable-next-line import/prefer-default-export
export const getProfileResource = async (contentFavoriteTotal) => {
  try {
    let url = 'v1/users/me/profile'

    if (contentFavoriteTotal) {
      url = `${url}?content_favorite_total=${contentFavoriteTotal}`
    }

    const res = await request.get(url)

    return serializers.userProfile(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}

// eslint-disable-next-line consistent-return
export const updateProfile = async (data) => {
  try {
    await request.patch(`v1/users/me`, data)
  } catch (err) {
    return Promise.reject(err)
  }
}
